//import 'waypoints/lib/jquery.waypoints.min.js';
import 'waypoints/lib/noframework.waypoints.js';
export function initSmoothScroll() {
	smoothScroll();
}

function smoothScroll() {
	$(document).ready(function () {
		const header_height = $('#header').height();
		const $sections =  $('.section-anchors');
		$sections.each(function () {
			const $section = $(this);
			const anchor_height = $section.height();
			const $anchors = $('[data-anchor]', $section);
			$anchors.each(function () {
				const anchor = $(this).data('anchor').replace('#', '');
				if ($('#' + anchor).length) {
					const $target = $('[data-anchor="' + anchor + '"]', $section);
					new Waypoint({
						element: document.getElementById(anchor),
						handler: function (d) {
							if(d == 'up') return
							$anchors.removeClass('active');
							$target.addClass('active');
						},
						offset: header_height + anchor_height + 5,
					});
					new Waypoint({
						element: document.getElementById(anchor),
						handler: function (d) {
							if(d == 'down') return
							$anchors.removeClass('active');
							$target.addClass('active');
						},

						offset: 0,
					});
				}
			});
		})
	});
	$(document).on(
		'click',
		'a[href*="#"]:not([href="#"]):not([href="#0"])',
		function (event) {
			let header_height = $('#header').height();
			let anchor_height = $('.section-anchors').height();
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					event.preventDefault();
					$('html, body').animate(
						{
							scrollTop: target.offset().top - (header_height + anchor_height) + 1,
						}
					);
				}
			}
		},
	);
}



// WEBPACK FOOTER //
// ./scripts/components/smoothScroll.ts